// components/Breadcrumbs.jsx
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumbs = ({ customPath = null }) => {
  const location = useLocation();
  const pathname = customPath || location.pathname;

  // Definește structura paginilor bazată pe sitemap-ul actual
  const pageStructure = {
    '/': { name: 'Acasă', parent: null },
    '/contact': { name: 'Contact', parent: '/' },
    '/preturi': { name: 'Prețuri ITP', parent: '/' },
    '/servicii': { name: 'Servicii ITP', parent: '/' },
    '/bucuresti-sector2': { name: 'București Sector 2', parent: '/' }
  };

  // Construiește calea breadcrumb
  const buildBreadcrumbPath = (currentPath) => {
    const path = [];
    let current = currentPath;

    while (current && pageStructure[current]) {
      path.unshift({
        name: pageStructure[current].name,
        url: current === '/' ? 'https://itp-sector2.ro' : `https://itp-sector2.ro${current}`
      });
      current = pageStructure[current].parent;
    }

    return path;
  };

  const breadcrumbPath = buildBreadcrumbPath(pathname);

  // Generează structured data pentru breadcrumbs
  const breadcrumbData = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": breadcrumbPath.map((item, index) => ({
      "@type": "ListItem",
      "position": index + 1,
      "name": item.name,
      "item": item.url
    }))
  };

  // Nu afișa breadcrumbs pe homepage
  if (pathname === '/' || breadcrumbPath.length <= 1) {
    return (
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />
    );
  }

  return (
    <>
      {/* Structured Data pentru Google */}
      <script 
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbData) }}
      />
      
      {/* Breadcrumbs vizibile pentru utilizatori */}
      <nav className="breadcrumbs" aria-label="Breadcrumb">
        <ol className="breadcrumb-list">
          {breadcrumbPath.map((item, index) => (
            <li key={index} className="breadcrumb-item">
              {index < breadcrumbPath.length - 1 ? (
                <>
                  <Link to={item.url.replace('https://itp-sector2.ro', '') || '/'}>
                    {item.name}
                  </Link>
                  <span className="breadcrumb-separator"> &gt; </span>
                </>
              ) : (
                <span className="breadcrumb-current" aria-current="page">
                  {item.name}
                </span>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
};

export default Breadcrumbs;